import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";

export default function AboutUs() {
  return (
    <div className="container-fluid">
      <Header />
      <div className="container-fluid viewh-85">
        <div className="row">
          <div className="col">
            <h1>
              <p className="text-center">
                <i>About Us</i>
              </p>
            </h1>
            <h4>iDecisionSciences</h4>
				<p className="fs-6 text-center">Established in 2009, the company has managed confidential supply chain data and provided software and professional services on behalf of the food industry.  Led by an experienced team of professionals with more than sixty combined years in the food industry, the team works to identify and understand client vulnerabilities and develop actionable plans. IDS strives to enable clients to have a better understanding of their vulnerabilities and provide them with the information and tools they need for clear direction and effective solutions.</p>
          
          </div>
        </div>
      </div>
      <div className="footer_container">
      <Footer />
      </div>
    </div>
  );
}
